import { render, staticRenderFns } from "./VesselHazards.vue?vue&type=template&id=4667d83c&scoped=true"
import script from "./VesselHazards.vue?vue&type=script&lang=js"
export * from "./VesselHazards.vue?vue&type=script&lang=js"
import style0 from "./VesselHazards.vue?vue&type=style&index=0&id=4667d83c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4667d83c",
  null
  
)

export default component.exports